<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'LISTS.TITLE' | translate }}
    </glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [maxWidth]="1160">
    <ng-container>
      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        [(selectedIndex)]="selectedTabIndex"
        (selectedTabChange)="navigateToTabIndex($event)"
        dynamicHeight
      >
        <mat-tab label="{{ 'LISTS.ACCOUNT_LIST.TITLE' | translate }}">
          <mat-card appearance="outlined">
            <va-filter-container [toolbarText]="toolbarText$ | async" (searchTermChanged)="updateSearchTerm($event)">
              <ng-container header>
                <a
                  class="header-button"
                  id="create-list"
                  mat-stroked-button
                  color="primary"
                  (click)="onCreateListPressed()"
                >
                  {{ 'LISTS.CREATE' | translate }}
                </a>
                <a
                  class="header-button"
                  id="import-list"
                  mat-flat-button
                  color="primary"
                  [routerLink]="accountListImportUrl"
                >
                  {{ 'LISTS.IMPORT' | translate }}
                </a>
              </ng-container>
            </va-filter-container>
            <va-table
              content
              [items]="actionLists$ | async"
              [tableViewModel]="actionListTable"
              [showLoadMore]="hasMore$ | async"
              [loadingMore]="loadingMore$ | async"
            ></va-table>
          </mat-card>
        </mat-tab>
        <mat-tab label="{{ 'LISTS.USER_LIST.TITLE' | translate }}">
          <app-user-lists-overview></app-user-lists-overview>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>
